import React, { useState } from 'react';
import { Play } from 'lucide-react';
import { VIDEO_ID } from '../../config/site';

export const HeroVideo = () => {
  const [playing, setPlaying] = useState(false);
  return (
    <div className="relative mx-auto aspect-video w-full overflow-hidden rounded-[20px] border border-line bg-black shadow-[0_0_60px_rgba(232,203,122,0.18)]">
      {playing ? (
        <iframe
          data-testid="hero-video-iframe"
          src={`https://www.youtube-nocookie.com/embed/${VIDEO_ID}?autoplay=1&rel=0&modestbranding=1&playsinline=1`}
          title="Intro-Video von Bican Coskun"
          className="absolute inset-0 h-full w-full"
          allow="autoplay; encrypted-media; picture-in-picture; fullscreen"
          allowFullScreen
        />
      ) : (
        <button
          type="button"
          onClick={() => setPlaying(true)}
          data-testid="hero-video-play-btn"
          aria-label="Intro-Video abspielen"
          className="group absolute inset-0 h-full w-full focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-inset focus-visible:ring-mint"
        >
          <img src="/video-poster.jpg" alt="" className="h-full w-full object-cover" fetchPriority="high" />
          <span className="absolute inset-0 bg-paper/30 transition-colors duration-300 group-hover:bg-paper/10" />
          <span className="absolute left-1/2 top-1/2 grid h-20 w-20 -translate-x-1/2 -translate-y-1/2 place-items-center gold-btn rounded-full text-paper shadow-xl transition-transform duration-300 group-hover:scale-105">
            <Play size={30} className="ml-1 fill-[#070B14]" aria-hidden="true" />
          </span>
          <span className="absolute bottom-3 left-1/2 -translate-x-1/2 whitespace-nowrap rounded-full bg-paper/80 px-3 py-1.5 text-[11px] text-white/80 backdrop-blur-md">
            Video wird beim Klick von YouTube geladen
          </span>
        </button>
      )}
    </div>
  );
};
